import { render, staticRenderFns } from "./HomeCareFasilitas.vue?vue&type=template&id=21c6fc2b"
import script from "./HomeCareFasilitas.vue?vue&type=script&lang=js"
export * from "./HomeCareFasilitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports